// extracted by mini-css-extract-plugin
module.exports = {"user-line-name":"user-avatar_user-line-name__uiYNu","user-image":"user-avatar_user-image__IXnGq"};